'use client';

import { Checkbox, GridItem } from '@coolblue-development/freddy';
import addToComparisonTrigger from '@coolblue-development/ga4-events/triggers/ItemCard/addToComparisonTrigger';
import removeFromComparisonTrigger from '@coolblue-development/ga4-events/triggers/ItemCard/removeFromComparisonTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';

export default function ComparisonCheckbox({
  index,
  total_indices,
  productId
}: {
  index: number;
  total_indices: number;
  productId: string;
}) {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();

  const handleOnChange = (event: { target: { checked: boolean } }) => {
    const params = {
      index: index,
      total_indices: total_indices,
      item_id: Number(productId)
    };
    if (event.target.checked) {
      trackEvent(addToComparisonTrigger(params));
    } else {
      trackEvent(removeFromComparisonTrigger(params));
    }
  };

  return (
    <GridItem>
      <Checkbox label={t('filterPage.comparisonCheckboxLabel')} onChange={handleOnChange} />
    </GridItem>
  );
}
